import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from "./shared/shared.module";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserModule }    from '@angular/platform-browser';
import { HttpClientModule, HttpResponse,HttpRequest,HttpHeaders, HttpClient,HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { I1, I2 } from './Http-Interceptor';
import { ToastrModule } from 'ngx-toastr';
import { AppComponent }   from './app.component';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { TwoColumnsLayoutComponent } from './layouts/2-columns-layout/2-columns-layout.component';
import { AuthService } from './shared/auth/auth.service';
import { AuthGuard } from './shared/auth/auth-guard.service';

import * as $ from 'jquery';
import { LoginComponent } from './login';

import swal from 'sweetalert2';
import { CustomerTypeComponent } from './customer-type/customer-type.component';
import { TicketTypeComponent } from './ticket-type/ticket-type.component';
import { AgencyCreationComponent } from './agency-creation/agency-creation.component';
import { ItneryComponent } from './itnery/itnery.component';
import { WebServiceService } from './web-service.service';
import { ChangePwdComponent } from './change-pwd/change-password-component';
// import { HomeComponent } from './home/home.component';
import { enableRipple } from '@syncfusion/ej2-base';

enableRipple(true);
/**
 * RTE overview Sample
 */
import { RichTextEditor, Toolbar, Link, Image,Count, HtmlEditor, QuickToolbar } from '@syncfusion/ej2-richtexteditor';
import { LoaderService } from './loader.service';
import { UnsoldTktsComponent } from './unsold-tkts/unsold-tkts.component';
import { PaymentResultComponent } from './payment-result/payment-result.component';
// import { TicketInventoryComponent } from './ticket-inventory/ticket-inventory.component';

RichTextEditor.Inject(Toolbar, Link, Image,Count, HtmlEditor, QuickToolbar);





@NgModule({
    declarations: [
        AppComponent,
//        OneColumnLayoutComponent,
        TwoColumnsLayoutComponent,
        LoginComponent,
        ChangePwdComponent,
        PaymentResultComponent,
        // TicketInventoryComponent
    ],
    imports: [
        BrowserAnimationsModule,
        // ClipboardModule,
        ToastrModule.forRoot( { closeButton:true,
            timeOut: 3000,
            progressBar:true,
            tapToDismiss:true } ),
        AppRoutingModule,
        HttpModule,
        SharedModule,
        BrowserModule,
        ReactiveFormsModule,
        HttpClientModule,
        FormsModule,
        
        NgbModule.forRoot()
    ],
    providers: [
        LoaderService,
        HttpClient,
        AuthService,
        AuthGuard,
        WebServiceService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: I1,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: I2,
            multi: true
        },
        {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts